import React from 'react';

interface ShiftBreachTooltipProps {
    x: number;
    y: number;
    lines: string[];
    shiftId: string;
    containerRef: React.RefObject<HTMLDivElement | null>;
    timeRange: string;
    employeeName: string;
    roleName: string;
}

const ShiftBreachTooltip: React.FC<ShiftBreachTooltipProps> = (
    {
        x,
        y,
        lines,
        shiftId,
        containerRef,
        timeRange,
        employeeName,
        roleName
    }) => {
    const calculatePosition = () => {
        const offset = 10;
        const containerWidth = containerRef.current?.clientWidth || 0;
        const viewportWidth = globalThis.innerWidth;
        const viewportHeight = globalThis.innerHeight;
        const containerRect = containerRef.current?.getBoundingClientRect();
        const estimatedWidth = 300;
        const estimatedHeight = 100 + (lines.length * 50);

        let left = x + offset;
        let top = y + offset;

        if (containerRect && (containerRect.left + left + estimatedWidth) > viewportWidth) {
            left = x - estimatedWidth - offset;
        }

        if (containerRect && (containerRect.top + top + estimatedHeight) > viewportHeight) {
            top = y - estimatedHeight - offset;
        }

        return {
            left: Math.max(8, Math.min(left, containerWidth - estimatedWidth)),
            top: Math.max(8, top)
        };
    };

    const position = calculatePosition();
    
    return (
        <div
            className="absolute z-[1000] bg-black/85 text-white rounded px-3 py-2 text-sm leading-relaxed pointer-events-none"
            style={{
                left: position.left,
                top: position.top,
            }}
        >
            <div className="font-bold text-base">{employeeName}</div>
            <div className="text-gray-300 font-medium">{roleName}</div>
            <div className="text-gray-400 mb-2">{timeRange}</div>

            {lines.length > 0 && (
                <>
                    <div className="h-px bg-gray-600 my-2"/>
                    <div className="font-semibold mb-1.5 text-red-400">Contraintes brisées pour ce quart</div>
                    {lines.map((line, lineIndex) => {
                        const parts = line.split('\n');
                        const mainText = parts[0];

                        return (
                            <div
                                key={`${shiftId}-${mainText}`}
                                className={lineIndex < lines.length - 1 ? 'mb-1' : ''}
                            >
                                - {mainText}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
};

export default ShiftBreachTooltip;
